module.exports = __webpack_public_path__ + "img/slider-8.dd519283.jpg";